'use strict';

var Constructor = require('js/vendor/constructor');
var $ = require('jquery');


// Head never moves
var $head = $('head');

// Meta tag names that use 'name' rather than 'property'
var META_NAMES = ['application-name', 'author', 'description', 'generator', 'keywords'];

/**
 * Core lib Head module [[Tests]](../test.html?grep=lib/head)
 * --------------------
 *  Note: This class makes the assumption you will not modify tags in the head manually but always use this api.
 *  Note: Link management only works with unique rel s currently
 *  Note: This class makes the assumption you only have unique meta tags. (OGP says this is not always the case - need a solution long term)
 *
 * @exports Head
 * @constructor
 * @alias module:lib/head
 */
var Head = Constructor.extend();

/**
 * Store of meta tags currently on the page
 * @type {Object}
 */
Head.prototype.metaTags = {};

/**
 * Store of link tags currently on the page
 * @type {Object}
 */
Head.prototype.linkTags = {};

/**
 * Store the title for the page
 *  NOTE: Don t modify this directly. Use set method.
 * @type {String}
 */
Head.prototype._title = '';

/**
 * Store a prefix for the title tag (useful for displaying unread messages etc)
 *  NOTE: Don t modify this directly. Use set method.
 * @type {String}
 */
Head.prototype._titlePrefix = '';

/**
 * Head initializer
 */
Head.prototype.initialize = function() {
  this.metaTags = {}; // Fresh obj
  this.linkTags = {}; // Fresh obj

  // Initial update
  this.update();
};

/**
 * Ensure we are tracking all meta tags on the page and ensure there is a description tag
 */
Head.prototype.update = function() {

  // Search for all meta tags
  $.makeArray($('meta')).forEach(function(element) {

    var $el = $(element);
    var name = $el.attr('name') || $el.attr('property');

    if (name) {
      this.metaTags[name] = $el;
    }

  }, this);

  // Search for all link tags
  $.makeArray($('link')).forEach(function(element) {

    var $el = $(element);
    var rel = $el.attr('rel');

    if (rel) {
      this.linkTags[rel] = $el;
    }

  }, this);
};

/**
 * Set the document title
 * @param {String} title
 */
Head.prototype.setTitle = function(title) {
  this._title = title;
  document.title = this._titlePrefix + title;
};

/**
 * Set the document title prefix (useful for unread messages etc.)
 * @param {String} title
 */
Head.prototype.setTitlePrefix = function(titlePrefix) {
  this._titlePrefix = titlePrefix;
  document.title = titlePrefix + this._title;
};

/**
 * Set the document description (meta tag)
 * @param {String} desc
 */
Head.prototype.setDescription = function(desc) {
  this.setMetaTag('description', desc);
};

/**
 * Get a jquery wrapped meta tag element (null if doesnt exist or we aren t managing it)
 * @param {String} name
 * @return {JQuery|null} content
 */
Head.prototype.getMetaTag = function(name) {
  return this.metaTags[name] || null;
};

/**
 * Remove a meta tag from the page
 * @param {String} name
 */
Head.prototype.removeMetaTag = function(name) {
  if (this.metaTags[name]) {
    this.metaTags[name].remove();
  }

  delete this.metaTags[name];
};

/**
 * Set the content of a meta tag on the page (just replaces existing content if it is already present)
 * @param {String} name
 * @param {String} content
 */
Head.prototype.setMetaTag = function(name, content) {
  var nameOrProperty;

  if (this.metaTags[name]) {
    this.metaTags[name].attr('content', content);
  } else {
    nameOrProperty = META_NAMES.indexOf(name) > -1 ? 'name' : 'property';
    this.metaTags[name] = $('<meta ' + nameOrProperty + '="' + name + '" content="' + content + '">').appendTo($head);
  }
};

/**
 * Set the meta tags with content we expect on the page (this removes tags off the page which arent in the object)
 *  NOTE: Description tag is not included in this clean up
 * @param {Object} tags map name:content
 */
Head.prototype.setMetaTags = function(tags) {
  // Remove exisitng tags not present in new set
  var name;

  for (name in this.metaTags) {
    if (this.metaTags.hasOwnProperty(name)) {
      if (!tags[name] && (name !== "viewport" && name !== "charset")) {
        this.removeMetaTag(name);
      }
    }
  }

  // Set all our new tags
  for (name in tags) {
    this.setMetaTag(name, tags[name]);
  }
};

/**
 * Get a jquery wrapped link tag (null if doesnt exist or not managed)
 * @param {String} rel
 * @return {Jquery|null} content
 */
Head.prototype.getLinkTag = function(rel) {
  return this.linkTags[rel] || null;
};

/**
 * remove a link tag from the page
 * @param {String} rel
 */
Head.prototype.removeLinkTag = function(rel) {
  if (this.linkTags[rel]) {
    this.linkTags[rel].remove();
  }

  delete this.linkTags[rel];
};

/**
 * Set the content (usually just href) of a link tag on the page
 * @param {String} rel
 * @param {String} href
 */
Head.prototype.setLinkTag = function(rel, href) {
  if (this.linkTags[rel]) {
    this.linkTags[rel].attr('href', href);
  } else {
    this.linkTags[rel] = $('<link rel="' + rel + '" href="' + href + '">').appendTo($head);
  }
};

/**
 * Set the link tags with content we expect on the page (this removes tags off the page which arent in the object)
 * @param {Object} tags map rel:href
 */
Head.prototype.setLinkTags = function(tags) {
  // Remove exisitng tags not present in new set
  var rel;

  for (rel in this.linkTags) {
    if (this.linkTags.hasOwnProperty(rel)) {
      if (!tags[rel]) {
        this.removeLinkTag(rel);
      }
    }
  }

  // Set all our new tags
  for (rel in tags) {
    if (tags.hasOwnProperty(rel)) {
      this.setLinkTag(rel, tags[rel]);
    }
  }
};

/**
 * Helper method to set link tags for prev and next pages in instances where we need pagination
 * @param {String|null} prevLink The previous page location
 * @param {String|null} nextLink The next page location
 */
Head.prototype.setPagination = function(prevLink, nextLink) {
  if (prevLink) {
    this.setLinkTag('prev', prevLink);
  } else {
    this.removeLinkTag('prev');
  }

  if (nextLink) {
    this.setLinkTag('next', nextLink);
  } else {
    this.removeLinkTag('next');
  }
};

module.exports = Head;



// WEBPACK FOOTER //
// ./app/assets/js/lib/head.js